import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Container, Column } from 'rbx';
import logoImage from '../../assets/images/logo-transitar.png'
import '../../styles/header.scss';

const Header = () => {

  return(
    <Navbar>
      <Container className='is-max-widescreen'>
        <Navbar.Brand className="ml-0">
          <Link to='/'>
            <img src={logoImage} alt="logoImage" />
          </Link>
          <Navbar.Burger />
        </Navbar.Brand>

        <Navbar.Menu id="navbar-menu">
          <Navbar.Segment className="navbar-item navbar-end" align="right">
            <Column.Group>
              <Column>
                <Link to="/login" className="button is-outlined is-custom-purple">Entrar</Link>
              </Column>
              <Column>
                <Link to="/activate" className="button is-outlined is-custom-purple">Ativar</Link>
              </Column>
            </Column.Group>
          </Navbar.Segment>
        </Navbar.Menu>
      </Container>
    </Navbar>
  )

}

export default Header;
